// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2YEI-","label":"LabeledBox_label__1LSUd"};